import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { ChecktagComponent } from "../../components/subscriptions-list/checktag/checktag";

@Component({
  selector: "subscriptions-tags-filter",
  templateUrl: "subscriptions-tags-filter.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ChecktagComponent, TranslatePipe],
})
export class SubscriptionsTagsFilterComponent {
  collectedTags = input.required<string[]>();
  protected hasTags = computed(() => this.collectedTags().length > 0);
}
